import { render, staticRenderFns } from "./SideContent.vue?vue&type=template&id=a2d671a2&scoped=true&lang=pug"
import script from "./SideContent.vue?vue&type=script&lang=js"
export * from "./SideContent.vue?vue&type=script&lang=js"
import style0 from "./SideContent.vue?vue&type=style&index=0&id=a2d671a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d671a2",
  null
  
)

export default component.exports